import {
  FETCHING_AGENT_LIST_SUCCESS,
  FETCHING_MEMBER_LIST,
  FETCHING_MEMBER_LIST_FAILURE,
  FETCHING_MEMBER_LIST_SUCCESS,
  LOAD_MEMBER_REMINDER_HISTORY,
  LOAD_USER_DASHBOARD_STATS,
  PASSWORD_CHANGE,
  PASSWORD_CHANGE_SUCCESS,
  RESET_LINK,
  RESET_LINK_SUCCESS,
  UPDATE_PAGE_FOR_MEMBER_INFO_LIST,
  UPDATE_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
} from "./userActionType";

const initialState = {
  dashboardStats: {
    current_month_total_revenue: 0,
    last_month_total_revenue: 0,
    current_month_pending_revenue: 0,
    last_month_pending_revenue: 0,
    current_month_onboarded_count: 0,
    last_month_onboarded_count: 0,
    total_entity_yearly_count: 0,
    total_entity_quarterly_count: 0,
    total_entity_monthly_count: 0,
    total_entity_yearly_revenue: 0,
    total_entity_quarterly_revenue: 0,
    total_entity_monthly_revenue: 0,
    total_entity_yearly_pending_revenue: 0,
    total_entity_quarterly_pending_revenue: 0,
    total_entity_monthly_pending_revenue: 0,
    top_mosques_by_revenue: [],
    top_mosques_by_members: [],
  },
  isResetLinkSend: false,
  isPasswordChange: false,
  memberInfo: {
    isFetching: false,
    isFetchingPaymentHistory: false,
    isFetchingReminderHistory: false,
    memberInfoList: [],
    memberInfoCount: 0,
    payments: [],
    memberInfoPayments: {},
    payment_history: [],
    total_payment_count: 0,
    reminder_history: [],
    total_reminder_count: 0,
    currentPage: 1,
    pageSize: 30,
  },
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER:
    case UPDATE_USER_FAILURE:
    case PASSWORD_CHANGE:
    case RESET_LINK:
    case LOAD_USER_DASHBOARD_STATS:
      return {
        ...state,
        dashboardStats: action.dashboardStats,
      };
    case UPDATE_USER_SUCCESS:
      const userData = state.agentsList.map((data) => {
        let details = { ...data };
        if (data?._id === action?.details?._id) {
          details.status = action?.details?.status;
          details.membership = action?.details?.membership;
          details.membership_date = action?.details?.membership_date;
          details.role = action?.details?.role;
          details.is_active = action?.details?.is_active;
        }
        return details;
      });

      return {
        ...state,
        isFetching: action.isFetching,
        user:
          state.user?._id === action.details?._id ? action.details : state.user,
        userList: userData,
      };

    case PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        isPasswordChange: action.isPasswordChange,
      };
    case FETCHING_MEMBER_LIST:
    case FETCHING_MEMBER_LIST_FAILURE:
      return {
        ...state,
        memberInfo: {
          ...state.memberInfo,
          isFetching: action.isFetching,
        },
      };

    case FETCHING_MEMBER_LIST_SUCCESS:
      return {
        ...state,
        memberInfo: {
          ...state.memberInfo,
          isFetching: action.isFetching,
          memberInfoList: action.list,
          memberInfoCount: action.count,
          payments: action.payments,
          memberInfoPayments: action.memberPayments,
          pageSize: action.pageSize,
          pageNum: action.pageNum,
        },
      };

    case UPDATE_PAGE_FOR_MEMBER_INFO_LIST:
      return {
        ...state,
        memberInfo: {
          ...state.memberInfo,
          currentPage: action.current,
        },
      };
    case RESET_LINK_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        isResetLinkSend: action.isResetLinkSend,
      };
     case LOAD_MEMBER_REMINDER_HISTORY:
      return {
        ...state,
        memberDetails: {
          ...state.memberDetails,
          reminder_history: [
            ...state.memberDetails?.reminder_history,
            ...action.reminder_history,
          ],
          total_reminder_count: action.total_reminder_count,
        },
      };  
    default:
      return state;
  }
};
export default userReducer;
